import { EventEmitter } from 'eventemitter3';

/**
 * Event emitter for recording-related events
 */
export const recordingEventEmitter = new EventEmitter();
